
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import { useContext } from 'react';
import CreatePosition from '../../../components/CreatePosition';
import { MetronomeContext } from '../../../components/MetronomeContext';
import Page from '../../../components/Page';
import getServerSideProps from '../../../utils/serverProps';
export default function SmartFarming({ hasError }) {
    const { t } = useTranslation();
    const { openTransactionDrawer } = useContext(MetronomeContext);
    return (<Page hasError={hasError} title={t('navigation.smartfarming')}>
      <CreatePosition onSubmit={() => openTransactionDrawer('leverage')}/>
    </Page>);
}
export {};

    async function __Next_Translate__getServerSideProps__1a0f35fc5aa__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[shortName]/smart-farming/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0f35fc5aa__ as getServerSideProps }
  